import { getLocalizedStrings } from '../profileSettingsLocalizedStrings';
import classes from './notificationSettings.scss';
import TextPreferences from './Presentational/textPreferences';
import TextBox from "../ProfileNotificationSettings/Presentational/addTextBox";

class NotificationTextSettings extends React.Component{

  constructor(props) {
    super(props);
    this.state = {
      editButtonPress:false,
      editText:"",
      addIconPress:false,
      enteredText:"",
      textExistErrMsg:"",
      cancelButtonPress:false,
      addTextExistErrMsg:"",encEditTextValue:"",seqNo:null,
      removeButtonPress:false,modifyTextError:"",newEditText:"",isError:false,textPrefErr:false,
      preferenceError:[],
      inputText:"",isNewTextValid:"",addCancelButtonPress:false, validationType:"phone",maxInputLength:13,
      removeTextPressed:false,removeText:'',phoneNo:'',isPhnError:'',isValidated:'',disabledAdd:true,isTextInvalid:false,disabledTextSave:"",
    };
    this.strings = getLocalizedStrings('NotificationSettings');
    this.textIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_TextOn.svg';
    this.addIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Action_Add.svg';
    this.warningIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Warning.svg';
    
  }
  
  getEnrollDetails(bpNumber,encryptedText){
    app.profileSettingsService.getEnrollDetails(this.props.bpNumber,encryptedText,"PAG").then((response) => {
      if (response.errorCode !== undefined && response.errorCode !== '') {
        //err
      } else {
        
      
        this.setPreference(response.impactedDevice);//impactedpreferences
       
      if(this.state.preferenceError.length>0 && this.state.encEditTextValue ){
    
        this.setState({textPrefErr:true}) ;}
        if(this.state.preferenceError.length>0 && this.state.removeText){
    
          this.setState({textPrefErr:true}) ;}
     
      } });
    }
    setPreference(preferences) {
      const updatedState = { ...this.state };
      updatedState.preferenceError = [];
      preferences.map((preference) => {
        if (preference.category === 'DEMR' && preference.messageType === 'CPP1') {
          updatedState.preferenceError.push('Critical Peak Pricing Notifications');//string to preference
        } else if (preference.category === 'PROG' && preference.messageType === 'BUDA') {
          updatedState.preferenceError.push('Budget Assistance Notifications');
        }
         else if (preference.category === 'OUTG' && preference.messageType === 'OUTG') {
          updatedState.preferenceError.push('Repair and Maintenance Alerts');
        }
        else if (preference.category === 'OUTG' && preference.messageType === 'EMRG') {
        updatedState.preferenceError.push('Emergency Alerts');
        }
      });
      this.setState(updatedState);
    }
  editHandler(e,text,record){
    window.aUtils.sendAAEvent("button","textEdit");
    const updatedState = { ...this.state };
    updatedState.editButtonPress = true, 
    updatedState.editText=text; 
    updatedState.encEditTextValue=record.encryptedvalue;
    updatedState.seqNo=record.sequenceNumber;
    updatedState.textExistErrMsg="";
    updatedState.modifyTextError=false;
    updatedState.isTextInvalid=false;
    updatedState.newEditText="";
    updatedState.textPrefErr=false;
    updatedState.removeButtonPress=false;
    updatedState.addIconPress=false, updatedState.disabledTextSave=false, this.setState(updatedState);
    this.getEnrollDetails(this.props.bpNumber,record.encryptedvalue);
    
}
cancelButtonHandler = () => {
  const updatedState = { ...this.state };
  updatedState.cancelButtonPress = true;
  updatedState.editButtonPress = false;
  updatedState.textExistErrMsg="";
  this.setState(updatedState);
  
}

textCallback(textValue){
  const updatedState = { ...this.state };
  updatedState.enteredText=textValue;
  updatedState.textExistErrMsg="";
  this.setState(updatedState,
    ()=>{this.isValidatedText(this.state.enteredText);});
}
addIconHandler(){ 
  const updatedState = { ...this.state };
  updatedState.addIconPress=true, updatedState.editButtonPress=false, updatedState.removeButtonPress=false, updatedState.addTextExistErrMsg="",updatedState.addTextError=false,updatedState.disabledAdd=true,this.setState(updatedState);
}
addTextCallback(newText,isNewTextValid){
  const updatedState = { ...this.state };
  updatedState.inputText=newText,updatedState.isNewTextValid=isNewTextValid;
  updatedState.addTextExistErrMsg="";
  this.setState(updatedState,
    ()=>{this.isValidatedText(this.state.inputText);});
  
  }
  isValidatedText(ph){
    if(ph.length===12){
     const updatedState = { ...this.state };
      updatedState.disabledAdd=false;
      updatedState.isTextInvalid=false,
      updatedState.disabledTextSave=false;
      this.setState(updatedState);
  
    }
    else{
       const updatedState = { ...this.state };
        updatedState.disabledAdd=true;
        updatedState.isTextInvalid=true;
        updatedState.disabledTextSave=true;
        this.setState(updatedState);
    }
  
  }
addButtonHandler(){
  this.setState({disabledAdd:true});
window.aUtils.sendAAEvent("button","addText");
const updatedState={...this.state};
let enteredValue = this.state.inputText.split("-").join("");
app.profileSettingsService.getEncryptedPhoneNumber(enteredValue).then(response=>{
if(!this.ifPhoneNoExists(response.phoneNumber)) {
  let encPhoneNumber;
  encPhoneNumber=response.phoneNumber;
  let voiceNumber = this.ifVoiceNoExists(response.phoneNumber);
  let reqObj={
    "deviceType":"text",    "addressGuid":this.props.data.addressGuid,    "modifiedValue": encPhoneNumber,
    "telephoneNumber":encPhoneNumber,  "indicatorSmsEnabled": "X", "indicatorTelephone": "2",
    "standardIndicatorPhoneNumber": "",    "objectKey": "",    "record_guid": "NEW",
    "channel": "PAG",    "sequenceNumber": voiceNumber ? voiceNumber.sequenceNumber : "",    "status": "",  "validToDate":"",    "removeFromDate": null,
    "addModifyFromDate": null,    "addModifyToDate": null
};
  app.profileSettingsService.modifyCustomerPreference(this.props.bpNumber, reqObj, !voiceNumber?true:null, null).then(response => {

    if (response.errorCode && response.errorCode !== ''){
      this.setState({addTextError:true});
     } 
    else {
      this.setState({addTextError:false});
      
      updatedState.editButtonPress = false,updatedState.addIconPress=false, updatedState.addTextExistErrMsg="";
      this.setState(updatedState);
      this.props.refreshNotification(); }
  });
}else{
  this.setState({addTextExistErrMsg:this.strings.textExistMsg});
}
});}
ifPhoneNoExists(phoneNo) {
  let phoneExist=false;
  
  _.each(this.props.data.text, function (record) {
    if (record.encryptedvalue === phoneNo)
      phoneExist=true;});
    return phoneExist;
  }
ifVoiceNoExists(phoneNo) {
  let voiceExist;  
  _.each(this.props.data.voice, function (record) {
    if (record.encryptedvalue === phoneNo)
    voiceExist=record;});
    return voiceExist;
  }
addCancelButtonHandler(){
  const updatedState={...this.state};
    updatedState.addCancelButtonPress=true, updatedState.addIconPress=false, updatedState.addTextExistErrMsg="", updatedState.disabledAdd=true, this.setState(updatedState);
}

saveButtonHandler(){
  this.setState({disabledTextSave:true});
window.aUtils.sendAAEvent("button","editTextSave"); 
const updatedState={...this.state};

if(this.state.enteredText!==""){
let text;
text=this.state.enteredText;
let enteredValue = text.split("-").join("");
  app.profileSettingsService.getEncryptedPhoneNumber(enteredValue).then(response=>{
    
    if(!this.ifPhoneNoExists(response.phoneNumber)) {
    let voiceNumber = this.ifVoiceNoExists(response.phoneNumber);
      if(!voiceNumber) {    
        let reqObj;
        
        reqObj={"deviceType":"text",    "addressGuid":this.props.data.addressGuid,    "modifiedValue": response.phoneNumber,
          "standardIndicatorPhoneNumber": "", "indicatorSmsEnabled": "X", "indicatorTelephone": "2",    "telephoneNumber":response.phoneNumber,    "objectKey": "",    "record_guid": "NEW",
          "channel": "PAG",    "sequenceNumber": this.state.seqNo,    "status": "", "removeFromDate": null,    "addModifyFromDate": null,    "addModifyToDate": null};
        
        app.profileSettingsService.modifyCustomerPreference(this.props.bpNumber, reqObj, null, null).then(response => {
          if (response.errorCode && response.errorCode !== ''){ 
            this.setState({modifyTextError:true});            
          } 
          else {            
            updatedState.modifyTextError=false,updatedState.editButtonPress = false,updatedState.addIconPress=false,updatedState.newEditText=this.state.enteredText,updatedState.enteredText="",updatedState.textExistErrMsg="",this.setState(updatedState);
            this.props.refreshNotification();
          }
        });
    } else {
      let delReqObj={ 'deviceType':'text','addressGuid':this.props.data.addressGuid,'modifiedValue': this.state.encEditTextValue,'sequenceNumber': this.state.seqNo};

      app.profileSettingsService.modifyCustomerPreference(this.props.bpNumber, delReqObj, null, true).then(delResponse => {
          if(delResponse.errorCode && delResponse.errorCode !== '') this.setState({modifyTextError:true});
          else {
            let editReqObj={"deviceType":"text",    "addressGuid":this.props.data.addressGuid,"modifiedValue": response.phoneNumber,
              "standardIndicatorPhoneNumber": "", "indicatorSmsEnabled": "X", "indicatorTelephone": "2","telephoneNumber":response.phoneNumber,"objectKey": "","record_guid": "NEW",
              "channel": "PAG",    "sequenceNumber": voiceNumber.sequenceNumber,    "status": "","removeFromDate": null,    "addModifyFromDate": null,    "addModifyToDate": null};

            app.profileSettingsService.modifyCustomerPreference(this.props.bpNumber, editReqObj, null, null).then(editResponse => {
                if(editResponse.errorCode && editResponse.errorCode !== '') this.setState({modifyTextError:true});
                else {
                  updatedState.modifyTextError=false,updatedState.editButtonPress = false,updatedState.addIconPress=false,updatedState.newEditText=this.state.enteredText,updatedState.enteredText="",updatedState.textExistErrMsg="",this.setState(updatedState);
                  this.props.refreshNotification();
                }
              });
          }
        });
    }
    
    }else{
     this.setState({textExistErrMsg:this.strings.textExistMsg});
     
    }});

}
else{
  this.setState({textExistErrMsg:this.strings.textExistMsg});
  
 }


}
//remove handler is used for handling the functionality of clicking on Cross button
removeHandler(e,encryptedText){
  const updatedState={...this.state};
  updatedState.textPrefErr=false;
  updatedState.removeButtonPress=true;
  updatedState.addIconPress=false;
  updatedState.editButtonPress=false;
  updatedState.removeText=encryptedText;
  this.getEnrollDetails(this.props.bpNumber,encryptedText);
  this.setState(updatedState);
}
//used for clicking on cancel
removeCancelHandler(){
  const updatedState={...this.state};
  updatedState.removeButtonPress=false;
  this.setState(updatedState);
}
//Delete button click functionality
deleteButtonHandler(e,sn){
 
  let  reqObj={ "deviceType":"text",    "addressGuid":this.props.data.addressGuid,    "modifiedValue": this.state.removeText,
    "standardIndicatorPhoneNumber": "", "indicatorSmsEnabled": "", "indicatorTelephone": "2",    "telephoneNumber":this.state.removeText,    "objectKey": "",    "record_guid": "NEW",
    "channel": "PAG",    "sequenceNumber": sn,    "status": "", "removeFromDate": null,    "addModifyFromDate": null,    "addModifyToDate": null};
  app.profileSettingsService.modifyCustomerPreference(this.props.bpNumber, reqObj, null, null).then(response => {
    if (response.errorCode && response.errorCode !== ''){
      this.setState({modifyTextError: true});
    }else{
      this.props.refreshNotification();
      const updatedState = { ...this.state };
      updatedState.removeButtonPress=false;
      updatedState.modifyTextError=false;
      this.setState(updatedState);
    }
  });
}
  render(){
    
    return(
      <div>

        <div className={classes.box}>
       
          <div className={classes.row}>
            <div  className={classes.rowheader}>
            <span> <img src={this.textIcon} alt='Text Icon' /> </span>                     
              <span className={classes.count}>{this.strings.text} ({this.props.data.text.length})</span> 
              { this.props.data.text.length>3 ?<div className={classes.viewAllButtonPadding}><button className={classes.viewAllButton} id="viewAllText" onClick={this.props.viewAllText.bind(this)}  >{this.strings.viewall}</button></div>:null}
            </div>
            <div className={classes.dividerLine} />   
            <TextPreferences type={this.state.validationType}
                    maxLength={this.state.maxInputLength}
                    data={this.props.data} preferenceDetails={this.state.preferenceDetails} removeHandler={this.removeHandler.bind(this)} removeCancelHandler={this.removeCancelHandler.bind(this)} deleteButtonHandler={this.deleteButtonHandler.bind(this)} editHandler={this.editHandler.bind(this)} editButton={this.state.editButtonPress} editText={this.state.editText} newText={this.state.newEditText}
            textCallback={this.textCallback.bind(this)} cancelButtonHandler={this.cancelButtonHandler.bind(this)} saveButtonHandler={this.saveButtonHandler.bind(this)} textExistErrMsg={this.state.textExistErrMsg} modifyTextError={this.state.modifyTextError}
            textPrefErr={this.state.textPrefErr} totalAccounts={this.props.CACTCount} encEditTextValue={this.state.encEditTextValue}  textData={this.state}
            placeHolder={!_.isEmpty(this.state.editText) ? this.state.editText : 'Enter Phone'} disabledTextSave={this.state.disabledTextSave} />
                   {this.state.addIconPress ? 
                <div>
                  <div className={classes.box}>
                    <span lassName={classes.textBox}>
                    
                <TextBox id='textInput'
                    type={this.state.validationType}
                    maxLength={this.state.maxInputLength}
                    validator={app.appUtil.validator} placeholder={"Enter phone"} addTextCallback={this.addTextCallback.bind(this)} emailValue={""} autoComplete="sceTextProfile" />
                       
                <span className={classes.saveCancelButtonAlign}>
               <button className={(this.state.disabledAdd) ? classes.disabledAddButton : classes.AddButton} onClick={this.addButtonHandler.bind(this)} disabled={this.state.disabledAdd} >{this.strings.AddButtonValue}</button>
                <button className={classes.CancelButton} onClick={this.addCancelButtonHandler.bind(this)}>{this.strings.CancelButtonValue}</button>
                </span> 
                </span>
                {this.state.addTextExistErrMsg ? <span className={classes.errMsg}>{this.state.addTextExistErrMsg}</span>: null}
                {this.state.addTextError ? <span className={classes.errMsg}>{this.strings.errorMsg}</span>: null} 
                <div className={classes.dividerLine} /> 
                </div>
                </div>: null}
                <div  className={classes.adding}>
                <button className={classes.addButton} onClick={this.addIconHandler.bind(this)}>
              <img src={this.addIcon} alt='Add Icon' onClick={this.addIconHandler.bind(this)} /> &nbsp;
              <span  className={classes.addnew}>{this.strings.addPhone}</span>
              </button>

            </div>
                 
          </div>
        </div>
      </div>

    );
  }
}
export default NotificationTextSettings;